'use client';
import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import MetaTags from '@/components/meta-tag/meta-tag';
import ClientCarousel from '@/components/home/client-carousel';
import UsaSpecializedSection from '@/components/common/usa-specialized-section';
import WhyMeetWithUs from '@/components/common/why-meet-with-us';
import LetsMeetInUsa from '@/components/common/lets-meet-in-usa';
import UsaSessionsInfo from '@/components/common/usa-sessions-info';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="section bg-sessions-usa py-50" id="section1">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <UsaSessionsInfo />
                        <ContactForm
                            wrapperClassName="md:col-span-6 lg:col-span-6"
                            title="Let's Meet in the USA"
                            subtitle={
                                <>
                                    From <span className="fw-700">6th to 27th May 2026</span>, we’re available for in-person
                                    meetings to explore growth, collaboration, and innovation.
                                </>
                            }
                            requestFromPage="lets-meet-usa"
                        />
                        {/* <UsaContactForm /> */}
                    </div>
                </div>
            </div>
            <ClientCarousel />
            <UsaSpecializedSection />
            <WhyMeetWithUs />
            <LetsMeetInUsa />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Enterprise Software Development?" />
            {/* <DividerSection /> */}
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <div className="section bg-primary py-100 dark:text-light">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
